<template>
  <div class="bds">
    <div class="bds-deco bds-deco--1" />
    <div class="bds-deco bds-deco--2" />

    <div class="bds-inner">
      <div class="bds-header">
        <div class="bds-brand">
          <div class="bds-brand__icon">
            <BaseIcon icon="md-briefcase" :size="24" color="#fff" />
          </div>
          <div class="bds-brand__text">
            <h1 class="bds-brand__title">投标工作总览</h1>
            <span class="bds-brand__sub">全库跟踪 {{ overview.tracking_count || 0 }} 项</span>
          </div>
        </div>
        <div class="bds-year-wrap">
          <select v-model.number="year" class="bds-year-native" @change="loadData">
            <option v-for="y in years" :key="y" :value="y">{{ y }}年</option>
          </select>
        </div>
      </div>

      <div class="bds-board">
        <div class="bds-board__main">
          <div class="bds-board__group">
            <div
              v-for="kpi in primaryKpis"
              :key="kpi.key"
              class="bds-cell"
              @click="goRoute(kpi.route)"
            >
              <div class="bds-cell__lbl">{{ kpi.label }}</div>
              <div class="bds-cell__val">
                {{ kpi.value }}<small v-if="kpi.unit">{{ kpi.unit }}</small>
              </div>
            </div>
          </div>

          <div class="bds-board__divider" aria-hidden="true" />

          <div class="bds-board__group">
            <div
              v-for="kpi in resultKpis"
              :key="kpi.key"
              class="bds-cell bds-cell--accent"
              @click="goRoute(kpi.route)"
            >
              <div class="bds-cell__lbl">{{ kpi.label }}</div>
              <div class="bds-cell__val">
                {{ kpi.value }}<small v-if="kpi.unit">{{ kpi.unit }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="bds-board__sub">
          <div
            v-for="item in subStats"
            :key="item.key"
            class="bds-tag"
            :class="{
              'bds-tag--warn': item.warn,
              'bds-tag--up': item.up,
              'bds-tag--link': !!item.route,
            }"
            @click="item.route ? goRoute(item.route) : undefined"
          >
            <span class="bds-tag__lbl">{{ item.label }}</span>
            <span class="bds-tag__val">{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {USE_MOCK, formatAmount, mockOverview} from './bid-dashboard-mock';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      overview: {},
    };
  },
  computed: {
    years() {
      const y = new Date().getFullYear();
      return [y, y - 1, y - 2];
    },
    primaryKpis() {
      return this.buildKpis().slice(0, 3);
    },
    resultKpis() {
      return this.buildKpis().slice(3);
    },
    subStats() {
      const o = this.overview;
      return [
        {key: 'info', label: '投标分析', value: `${o.info_count || 0} 项`, route: 'info'},
        {key: 'wtotal', label: '投标工作', value: `${o.work_total || 0} 项`, route: 'work'},
        {key: 'wait', label: '等待开标', value: `${o.waiting_open || 0} 项`, route: 'open'},
        {key: 'urgent', label: '紧急在投', value: `${o.urgent_work || 0} 项`, warn: (o.urgent_work || 0) > 0, route: 'work'},
        {key: 'bond', label: '待退保证金', value: `${o.bond_pending || 0} 笔`, warn: (o.bond_pending || 0) > 0, route: 'open'},
        {key: 'month', label: '本月新增', value: `${o.new_this_month || 0} 项`, up: true},
        {key: 'audit', label: '待审核', value: `${o.pending_audit || 0} 项`, route: 'info'},
        {key: 'yoy', label: '同比增长', value: o.yoy_growth ? `+${o.yoy_growth}%` : '—', up: !!o.yoy_growth},
      ];
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    buildKpis() {
      const o = this.overview;
      return [
        {key: 'track', label: '控制价总额', value: formatAmount(o.tracking_amount), unit: '', route: 'info'},
        {key: 'work', label: '在投项目', value: o.active_work || 0, unit: '项', route: 'work'},
        {key: 'open', label: '已开标', value: o.opened_count || 0, unit: '项', route: 'open'},
        {key: 'win', label: '中标项目', value: o.win_count || 0, unit: '项', route: 'open'},
        {key: 'rate', label: '中标率', value: o.win_rate || 0, unit: '%', route: 'open'},
        {key: 'winamt', label: '中标金额', value: formatAmount(o.win_amount), unit: '', route: 'open'},
      ];
    },
    loadData() {
      if (USE_MOCK) {
        this.overview = mockOverview();
        return;
      }
      this.$api.get('/business/bid/dashboard/overview', {year: this.year}).then((res) => {
        this.overview = res.data.data;
      }).catch(() => {
        this.overview = mockOverview();
      });
    },
    goRoute(route) {
      const base = this.$route.path.replace(/\/[^/]+$/, '');
      this.RouteTo(`${base}/${route}`);
    },
  },
};
</script>

<style lang="less" scoped>
.bds {
  position: relative;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(160deg, #083566 0%, #0d4a8f 42%, #1a6fd4 100%);
  box-shadow: 0 4px 18px rgba(8, 53, 102, 0.28);
}

.bds-deco {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;

  &--1 {
    width: 220px;
    height: 220px;
    top: -80px;
    right: -20px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 68%);
  }

  &--2 {
    width: 160px;
    height: 160px;
    bottom: -50px;
    left: 10%;
    background: radial-gradient(circle, rgba(110, 176, 245, 0.18) 0%, transparent 70%);
  }
}

.bds-inner {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 14px 8px;
  box-sizing: border-box;
}

.bds-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
}

.bds-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.bds-brand__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bds-brand__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  letter-spacing: 0.06em;
}

.bds-brand__sub {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.bds-year-wrap {
  position: relative;
  padding: 0 24px 0 12px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 20px;
  backdrop-filter: blur(4px);
  flex-shrink: 0;
  transition: background 0.15s;

  &::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -2px;
    border: 4px solid transparent;
    border-top-color: rgba(255, 255, 255, 0.85);
    pointer-events: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}

.bds-year-native {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  padding: 0;

  option {
    color: #1e3a5f;
    background: #fff;
  }
}

.bds-board {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(8, 53, 102, 0.18);
}

.bds-board__main {
  flex: 1;
  display: flex;
  align-items: stretch;
  min-height: 0;
}

.bds-board__group {
  flex: 1;
  display: flex;
  align-items: stretch;
  min-width: 0;
}

.bds-board__divider {
  width: 1px;
  flex-shrink: 0;
  margin: 12px 0;
  background: linear-gradient(180deg, transparent, #d6e8fb 20%, #d6e8fb 80%, transparent);
}

.bds-cell {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 6px;
  cursor: pointer;
  transition: background 0.15s;
  position: relative;

  & + &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 18%;
    bottom: 18%;
    width: 1px;
    background: #eef4fc;
  }

  &:hover {
    background: #f5faff;
  }

  &--accent {
    .bds-cell__val {
      color: #c2410c;
    }
  }
}

.bds-cell__lbl {
  font-size: 12px;
  font-weight: 500;
  color: #6b8aad;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.bds-cell__val {
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  color: #0d4a8f;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  small {
    font-size: 13px;
    font-weight: 700;
    margin-left: 2px;
    color: #6b8aad;
  }
}

.bds-board__sub {
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
  padding: 0 10px;
  height: 28px;
  background: rgba(240, 246, 253, 0.9);
  border-top: 1px solid #e3eef9;
  overflow: hidden;
}

.bds-tag {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 100%;
  padding: 0 4px;
  position: relative;
  white-space: nowrap;

  & + &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 22%;
    bottom: 22%;
    width: 1px;
    background: #d6e8fb;
  }

  &--link {
    cursor: pointer;

    &:hover .bds-tag__val {
      color: #1a6fd4;
    }
  }

  &--warn .bds-tag__val {
    color: #c2410c;
  }

  &--up .bds-tag__val {
    color: #15803d;
  }
}

.bds-tag__lbl {
  font-size: 11px;
  color: #9cb8d8;
}

.bds-tag__val {
  font-size: 12px;
  font-weight: 700;
  color: #1e3a5f;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
